<div
  class="authentication-main"
  style="
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
  "
>
  <!-- Custom Snackbar Alert (using styles from SCSS) -->
  <div
    class="custom-snackbar"
    [ngClass]="{
      show: showAlert,
      success: alertType === 'success',
      error: alertType === 'error'
    }"
    *ngIf="showAlert"
  >
    <!-- Icon Placeholder (simple unicode characters for visual feedback) -->
    <span class="custom-snackbar-icon">
      <ng-container *ngIf="alertType === 'success'">&#x2714;</ng-container>
      <!-- Checkmark -->
      <ng-container *ngIf="alertType === 'error'">&#x2716;</ng-container>
      <!-- X mark -->
    </span>
    {{ alertMessage }}
  </div>

  <!-- NOTE: Asset paths like /assets/images/wave.png and /assets/images/UASLOGO.jpg need to be relative to the app's root in a real Angular setup. -->
  <img
    class="wave"
    src="/assets/images/wave.png"
    alt="Wave background"
    style="
      position: absolute;
      left: -120px;
      width: 620px;
      opacity: 0.95;
      pointer-events: none;
    "
  />

  <!-- Main Content Card Container: Removed fixed height/scrolling to expand with content -->
  <div
    class="card3"
    style="
      max-width: 920px;
      width: 100%;
      position: relative;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      /* Removed max-height and overflow: auto to allow expansion */
      margin-top: 5vh; /* Added margin-top to position card lower */
      margin-bottom: 72px; /* Increased margin-bottom to clear fixed footer */
    "
  >
    <div
      class="container3"
      style="
        padding: 24px;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
      "
    >
      <!-- Header Section - STICKY (Ensures logo is visible) -->
      <div
        class="admit-header-centered"
        style="
          text-align: center;
          width: 100%;
          margin-bottom: 20px; /* Space before form */
          position: sticky;
          top: 0;
          z-index: 10;
        "
      >
        <img
          src="/assets/images/UASLOGO.jpg"
          alt="Logo"
          class="admit-logo-centered"
          style="
            width: 100%;
            max-width: 450px;
            height: auto;
            object-fit: contain;
          "
        />
        <div
          style="
            font-weight: 700;
            color: #198754;
            font-size: 18px;
            margin-top: 6px;
          "
        >
          UNIVERSITY OF AGRICULTURAL SCIENCES
        </div>
        <div style="font-size: 13px; color: #0d6efd">
          University Examination Centre
        </div>
      </div>

      <!-- Login/OTP Content -->
      <div
        class="login-content"
        style="width: 100%; max-width: 400px; padding-top: 10px"
      >
        <h4
          class="mb-4"
          style="text-align: center; font-weight: 600; color: #333"
        >
          Download Admit Card / Call Letter
        </h4>

        <!-- OTP/Verification Form: HIDDEN if otpVerified is TRUE -->
        <ng-container *ngIf="!otpVerified">
          <form [formGroup]="form">
            <div class="form-group mb-3" [ngClass]="{'has-error': form.get('recruitmentId')?.invalid && form.get('recruitmentId')?.touched}">
              <label for="recruitmentId" style="font-size: 14px; font-weight: 500">Recruitment Post <span class="text-danger">*</span></label>
              <select
                id="recruitmentId"
                class="form-control"
                formControlName="recruitmentId"
                style="border-radius: 4px; padding: 10px"
              >
                <option value="">Select Recruitment Post</option>
                <option *ngFor="let item of recruitmentList" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
              <div
                *ngIf="form.get('recruitmentId')?.invalid && form.get('recruitmentId')?.touched"
                style="color: red; font-size: 13px; margin-top: 4px"
              >
                Please select a recruitment post
              </div>
            </div>
            <!-- Mobile Number Input -->
            <div class="form-group mb-3">
              <label for="mobile" style="font-size: 14px; font-weight: 500"
                > Mobile Number <span class="text-danger">*</span></label
              >
              <input
                id="mobile"
                type="tel"
                class="form-control"
                formControlName="mobile"
                placeholder="Enter 10-digit Mobile Number"
                inputmode="numeric"
                maxlength="10"
                (input)="onMobileInput($event)"
                style="border-radius: 4px; padding: 10px"
              />
              <div
                *ngIf="
                  form.get('mobile')?.invalid &&
                  (form.get('mobile')?.dirty || form.get('mobile')?.touched)
                "
                style="color: red; font-size: 13px; margin-top: 4px"
              >
                Enter a valid 10 digit mobile number
              </div>
            </div>

            <!-- Get OTP/Resend Button: Vibrant Green #37C68B -->
            <div style="margin-top: 8px">
              <button
                type="button"
                class="btn btn-primary w-100"
                (click)="getOtp()"
                [disabled]="loading || form.get('mobile')?.invalid"
                style="
                  background-color: #37c68b; /* Vibrant Green */
                  color: white;
                  border: none;
                  padding: 8px 10px; /* Reduced padding for smaller size */
                  border-radius: 20px; /* Highly rounded corners */
                  cursor: pointer;
                  transition: background-color 0.3s;
                  box-shadow: 0 4px 6px rgba(55, 198, 139, 0.4);
                "
              >
                <span *ngIf="loading">Processing...</span>
                <span *ngIf="!loading && !otpSent"> Get OTP</span>
                <span *ngIf="!loading && otpSent"> Resend OTP</span>
              </button>
            </div>
          </form>

          <!-- OTP Verification Section -->
          <div
            *ngIf="otpSent"
            style="
              margin-top: 16px;
              padding-top: 16px;
              border-top: 1px solid #eee;
            "
          >
            <form [formGroup]="form">
              <div class="form-group mb-3">
                <label for="otp" style="font-size: 14px; font-weight: 500"
                  >Enter OTP</label
                >
                <input
                  id="otp"
                  type="text"
                  class="form-control"
                  formControlName="otp"
                  placeholder="Enter OTP"
                  style="border-radius: 4px; padding: 10px"
                />
                <div
                  *ngIf="
                    form.get('otp')?.invalid &&
                    (form.get('otp')?.dirty || form.get('otp')?.touched)
                  "
                  style="color: red; font-size: 13px; margin-top: 4px"
                >
                  OTP is required for verification.
                </div>
              </div>

              <div style="margin-top: 8px">
                <button
                  type="button"
                  class="btn btn-success w-100 verify-btn"
                  (click)="verifyOtp()"
                  [disabled]="loading || form.get('otp')?.invalid"
                  style="
                    background-color: #37c68b; /* Vibrant Green */
                    color: white;
                    border: none;
                    padding: 8px 10px; /* Reduced padding */
                    border-radius: 20px; /* Highly rounded corners */
                    cursor: pointer;
                    transition: background-color 0.3s;
                    box-shadow: 0 4px 6px rgba(55, 198, 139, 0.4);
                  "
                >
                  <span
                    class="spinner"
                    *ngIf="loading"
                    aria-hidden="true"
                    style="
                      width: 14px;
                      height: 14px;
                      border-radius: 50%;
                      border: 2px solid rgba(255, 255, 255, 0.3);
                      border-top-color: #fff;
                      margin-right: 8px;
                      animation: spin 0.8s linear infinite;
                    "
                  ></span>
                  <span *ngIf="loading"> ...</span>
                  <span *ngIf="!loading"> Verify OTP</span>
                </button>
              </div>
            </form>
          </div>
        </ng-container>

        <!-- Download Links Section (Only visible after verification) -->
        <div
          *ngIf="otpVerified"
          style="margin-top: 20px; padding-top: 20px; text-align: center"
        >
          <p style="font-weight: 600; color: #333">Verification Successful!</p>
          <p style="font-size: 14px; color: #666; margin-bottom: 16px">
            Candidate ID:
            <span style="font-weight: 700; color: #0d6efd">{{ rollNo }}</span>
          </p>
          <!-- Download Buttons: Inline, responsive row -->
          <div
            style="
              display: flex;
              gap: 8px;
              flex-direction: row;
              justify-content: center;
              flex-wrap: wrap;
            "
          >
            <!-- Admit Card -->
            <button
              class="btn btn-outline-primary download-btn"
              (click)="generateReport('admitcard')"
              [disabled]="loading"
            >
              <ng-container
                *ngIf="loading && currentReport === 'admitcard'; else admitIcon"
              >
                <span class="spinner" style="margin-right: 6px"></span>
                Downloading...
              </ng-container>
              <ng-template #admitIcon>
                <!-- File Text Icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  style="margin-right: 6px"
                >
                  <path
                    d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
                  ></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <line x1="10" y1="9" x2="8" y2="9"></line>
                </svg>
                Admit Card
              </ng-template>
            </button>

            <!-- Call Letter -->
            <button
              class="btn btn-outline-primary download-btn"
              (click)="generateReport('callletter')"
              [disabled]="loading"
            >
              <ng-container
                *ngIf="loading && currentReport === 'callletter'; else callIcon"
              >
                <span class="spinner" style="margin-right: 6px"></span>
                Downloading...
              </ng-container>
              <ng-template #callIcon>
                <!-- Mail Icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  style="margin-right: 6px"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  ></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Call Letter
              </ng-template>
            </button>

            <!-- Instruction -->
            <button
              class="btn btn-outline-primary download-btn"
              (click)="generateReport('instruction')"
              [disabled]="loading"
            >
              <ng-container
                *ngIf="
                  loading && currentReport === 'instruction';
                  else instructionIcon
                "
              >
                <span class="spinner" style="margin-right: 6px"></span>
                Downloading...
              </ng-container>
              <ng-template #instructionIcon>
                <!-- Book Open Icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  style="margin-right: 6px"
                >
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
                Instruction
              </ng-template>
            </button>
          </div>
        </div>

        <div *ngIf="loading" class="mt-3 text-center">
          <small style="color: #0d6efd">Processing...</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Section: Fixed to the bottom of the viewport (FULL WIDTH) -->
  <div class="row">
    <!-- <div class="col-md-6 footer-copyright">
      <p class="mb-0">
        ©2020 UAS(B) | Funded By:<a
          href="https://icar.org.in/"
          style="color: #0080ff"
          alt="ICAR(New Delhi), UAS(Bengaluru)"
          title="Click this will open the site in new tab."
          target="_blank"
          >ICAR(New Delhi), UAS(Bengaluru)</a
        >
      </p>
    </div> -->

    <div class="col-md-12">
      <p class="pull-right mb-0">
        Powered by :
        <a
          href="https://spherebox.tech/"
          style="color: #0080ff"
          alt="spherebox.in"
          title="Click this will open the site in new tab."
          target="_blank"
        >
          Spherebox Technologies Private Limited</a
        >
      </p>
    </div>
  </div>
</div>

<!-- Basic Keyframes for the spinner, since Angular templates don't support external CSS easily -->
<style>
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  .spinner {
    animation: spin 0.8s linear infinite;
  }
</style>
